import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {BaseError} from '../types/apiTypes';
import {useLogoutMutation} from '../store/api/authApi';
import {messageType, showMessages} from '../helpers/message';
import {useAppDispatch} from '../hooks/useStore';
import {setLogout} from '../store/slices/userSlice';

import "./Logout.less";

const Logout = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [logout] = useLogoutMutation();

    useEffect(() => {
        const handleLogout = async () => {
            try {
                await logout();
                dispatch(setLogout());
            } catch (error) {
                showMessages((error as BaseError).data?.message, messageType.error);
            } finally {
                navigate('/login');
            }
        };
        handleLogout();
    }, [dispatch, logout, navigate])

    return null;
}

export default Logout;
